import { render, staticRenderFns } from "./text-carousel.vue?vue&type=template&id=5405e202&"
import script from "./text-carousel.vue?vue&type=script&lang=js&"
export * from "./text-carousel.vue?vue&type=script&lang=js&"
import style0 from "./text-carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports